export default "__VITE_ASSET__CtMe78VS__"